var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6394 2.66602H12.3594V8.47935H19.6394V2.66602Z",
    fill: "#FF7E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6406 2.66602V8.47935H29.1606C28.4806 4.81268 25.774 2.67935 21.6406 2.66602Z",
    fill: "#FF7E84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67188 10.4805V21.5871C2.67188 26.4405 5.56521 29.3338 10.4185 29.3338H21.5919C26.4452 29.3338 29.3385 26.4405 29.3385 21.5871V10.4805H2.67188ZM19.2585 21.5738L16.4852 23.1738C15.8985 23.5071 15.3252 23.6805 14.7919 23.6805C14.3919 23.6805 14.0319 23.5871 13.6985 23.4005C12.9252 22.9605 12.4985 22.0538 12.4985 20.8805V17.6805C12.4985 16.5071 12.9252 15.6005 13.6985 15.1605C14.4719 14.7071 15.4585 14.7871 16.4852 15.3871L19.2585 16.9871C20.2852 17.5738 20.8452 18.4005 20.8452 19.2938C20.8452 20.1871 20.2719 20.9738 19.2585 21.5738Z",
    fill: "#FF7E84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3637 2.66602C6.23042 2.67935 3.52375 4.81268 2.84375 8.47935H10.3637V2.66602Z",
    fill: "#FF7E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.106aac236f01dfc5a33f58a821495a62.svg";
export { ForwardRef as ReactComponent };